export const environment = {
  production: true,
  apiUrl: 'https://uat.api.halloalberta.de',
  templateBuilderUrl: 'https://tb.halloalberta.de',
};
